import { useEffect, useState } from 'react'
import api from '../api/client'
import Loader from '../components/Loader'
import { FileText, CheckCircle2, Clock, XCircle, Target, DollarSign, TrendingUp } from 'lucide-react'

const money = (v) => 'R$ ' + Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
const num = (v) => Number(v || 0).toLocaleString('pt-BR')

function Card({ icon: Icon, label, value, color, textColor }) {
  return (
    <div className="bg-white rounded-2xl p-4 sm:p-5 shadow-sm border border-gray-100">
      <div className={`w-10 h-10 rounded-xl bg-gradient-to-br ${color} flex items-center justify-center shadow mb-3`}>
        <Icon size={18} className="text-white" />
      </div>
      <p className="text-2xl font-heading font-bold text-gray-900">{value}</p>
      <p className={`text-xs font-medium ${textColor} mt-1`}>{label}</p>
    </div>
  )
}

export default function FaturasPainel() {
  const [d, setD] = useState(null)
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    api.get('/faturas/_dashboard').then((r) => setD(r.data)).catch(() => setD(null)).finally(() => setLoading(false))
  }, [])

  if (loading) return <div className="flex items-center justify-center h-[60vh]"><Loader size="lg" text="Carregando painel..." /></div>
  if (!d) return <p className="text-gray-500">Não foi possível carregar o painel.</p>

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-heading font-bold text-gray-900">Painel de Faturas</h1>
        <p className="text-sm text-gray-500 mt-0.5">Indicadores do mês corrente · faturas, PV, comissões e receita recorrente.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        <Card icon={FileText} label="Faturas Importadas" value={num(d.importadas)} color="from-indigo-400 to-violet-400" textColor="text-indigo-700" />
        <Card icon={CheckCircle2} label="Faturas Pagas" value={num(d.pagas)} color="from-emerald-400 to-teal-400" textColor="text-emerald-700" />
        <Card icon={Clock} label="Faturas Pendentes" value={num(d.pendentes)} color="from-amber-400 to-orange-400" textColor="text-amber-700" />
        <Card icon={XCircle} label="Canceladas/Estornadas" value={num(d.canceladas)} color="from-rose-400 to-pink-400" textColor="text-rose-700" />
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
        <Card icon={Target} label="PV Gerado no Mês" value={num(d.pv_mes)} color="from-blue-400 to-cyan-400" textColor="text-blue-700" />
        <Card icon={DollarSign} label="Comissões Geradas (mês)" value={money(d.comissoes_mes)} color="from-emerald-400 to-teal-400" textColor="text-accent-700" />
        <Card icon={TrendingUp} label="Receita Recorrente" value={money(d.receita_recorrente)} color="from-amber-400 to-orange-400" textColor="text-primary-700" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
          <h3 className="font-heading font-semibold text-gray-900 mb-3">Receita por Parceiro</h3>
          {(d.receita_parceiro || []).length === 0 && <p className="text-sm text-gray-400">Sem dados.</p>}
          <div className="space-y-2">
            {(d.receita_parceiro || []).map((p, i) => (
              <div key={i} className="flex items-center justify-between text-sm border-b border-gray-50 pb-1.5">
                <span className="text-gray-700">{p.parceiro}</span>
                <span className="font-semibold text-gray-900">{money(p.valor)}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
          <h3 className="font-heading font-semibold text-gray-900 mb-3">Receita por Licenciado (top 10)</h3>
          {(d.receita_licenciado || []).length === 0 && <p className="text-sm text-gray-400">Sem dados.</p>}
          <div className="space-y-2">
            {(d.receita_licenciado || []).map((p, i) => (
              <div key={i} className="flex items-center justify-between text-sm border-b border-gray-50 pb-1.5">
                <span className="text-gray-700">{p.licenciado}</span>
                <span className="font-semibold text-gray-900">{money(p.valor)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
